import { ProgramProgressionStatus } from "@modules/programs/programOnOffTypes"
import { z } from "zod"

export const OnOffProgramProgressionDtoSchema = z.object({
  programId: z.string(),
  userId: z.string(),
  currentIndex: z.number(),
  duration: z.number(),
  startedAt: z.string().nullable(),
  stoppedAt: z.string().nullable(),
  status: z.nativeEnum(ProgramProgressionStatus),
})

export type OnOffProgramProgressionDto = z.infer<typeof OnOffProgramProgressionDtoSchema>
